import { sum } from "../../utils/array"
import { IMapDimensions, IMapMeasuringService } from "./types"
import { ol_Feature, ol_geom, ol_Coordinate, ol_proj } from "@omnia/exports/openlayers";
import * as sphere from "ol/sphere"

/** @internal */
export class MapMeasuringServiceWgs84 implements IMapMeasuringService {


    constructor() {
    }

    getDistance(c1: ol_Coordinate, c2: ol_Coordinate, sourceProj: string = "EPSG:3857"): number {

        const prj = "EPSG:4326"

        c1 = ol_proj.transform(c1, sourceProj, prj)
        c2 = ol_proj.transform(c2, sourceProj, prj)

        const length = sphere.getDistance(c1, c2)

        return length

    }

    getArea(geometry: ol_geom.Geometry | ol_Feature, sourceProj: string = "EPSG:3857") {
        return this.getDimensions(geometry, sourceProj).area
    }

    getLength(geometry: ol_geom.Geometry | ol_Feature, sourceProj: string = "EPSG:3857"): number {
        return this.getDimensions(geometry, sourceProj).length
    }

    getDimensions(geometry: ol_geom.Geometry | ol_Feature, sourceProj: string = "EPSG:3857"): IMapDimensions {

        let g: any = geometry instanceof ol_Feature
            ? geometry.getGeometry()
            : geometry


        if (g instanceof ol_geom.GeometryCollection) {

            const dimensions = g.getGeometries().map(g => this.getDimensions(g, sourceProj))

            return {
                area: sum(dimensions, d => d.area),
                length: sum(dimensions, d => d.length)
            }

        }

        if (g instanceof ol_geom.Circle) {

            return this.getCircleDimensions(g, sourceProj)

        }

        if (g && g.clone) {

            return {
                area: this.getGeomArea(g, sourceProj),
                length: this.getGeomLength(g, sourceProj)
            }

        }

        return {
            area: undefined,
            length: undefined
        }

    }


    private getGeomLength(geom: ol_geom.Geometry, sourceProj: string) {

        return sphere.getLength(geom, { projection: sourceProj })

    }


    private getGeomArea(geom: ol_geom.Geometry, sourceProj: string) {

        return sphere.getArea(geom, { projection: sourceProj })

    }


    private getCircleDimensions(circle: ol_geom.Circle, sourceProj: string) {

        const radius = this.getProjectedDistance(circle.getCenter(), circle.getRadius(), sourceProj)

        return {
            area: Math.PI * radius * radius,
            length: Math.PI * 2 * radius
        }

    }

    getProjectedDistance(center: ol_Coordinate, distance: number, sourceProj: string = "EPSG:3857"): number {
        const p1 = center
        const p2 = [center[0] + distance, center[1]]
        const projDistance = Math.abs(this.getDistance(p1, p2, sourceProj))

        const result = (projDistance > 0)
            ? distance * (distance / projDistance)
            : distance

        return result

    }


}
